import React from 'react'
import { Badge } from 'react-bootstrap'

const BatchLabel = ({
    count
}) => {
    const label = count > 1 || count < 1 ? 'people' : 'person'
    return (
        <div
            style={{
                display: 'inline-block',
                paddingLeft: '3px'
            }}
        >
            <Badge variant='secondary' >
                {count} {label}
            </Badge>
        </div>
    )
}

export default BatchLabel
